/* eslint-disable */
function _alert(message) {
  alert(message);
}
function _confirm(message) {
  return confirm(message);
}
function _prompt(message, defaultText) {
  return prompt(message, defaultText);
}
export default {
  alert: _alert,
  confirm: _confirm,
  prompt: _prompt
};

